var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.typeClass},[_c('i',{class:_vm.iconClass}),_c('span',{staticClass:"count-numbers"},[_vm._v(_vm._s(Number(_vm.text).toLocaleString()))]),_c('span',{staticClass:"count-name text-uppercase"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }